import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors, TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  root: {
    '& $breadcrumb': {
      '& a': {
        color: SecondaryColors.main,

        '&:hover': {
          color: SecondaryColors.light,
        },
      },
      '& .MuiBreadcrumbs-separator': {
        color: hexToRGBA(TextColors.light, TextOpacities.light3),
      },
    },
  },
};

const lightTheme = {
  root: {
    '& $breadcrumb': {
      '& a': {
        color: SecondaryColors.dark,

        '&:hover': {
          color: SecondaryColors.main,
        },
      },
      '& .MuiBreadcrumbs-separator': {
        color: hexToRGBA(TextColors.dark, TextOpacities.dark3),
      },
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      flexGrow: 1,

      '& > *': {
        width: '100%',
      },
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      alignContent: 'center',
      width: '100%',
    },
    footer: {
      alignSelf: 'flex-end',
    },
    breadcrumb: {
      '& p': {
        color: 'inherit !important',
      },
    },
    backLink: {
      ...muiTheme.typography.h5,

      '& .MuiSvgIcon-root:first-child': {
        marginLeft: '-6px',
      },
    },
    relatedContent: {
      // '& .content-container__content': {
      //   [muiTheme.breakpoints.down('sm')]: {
      //     paddingTop: '0 !important',
      //   },
      // },
    },
  }),
  { name: 'GenCustomerStory' },
);

export default useStyles;
